
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 60 60"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('linearGradient',{attrs:{"x1":"50%","y1":"3.325%","x2":"50%","y2":"99.716%","id":"a"}},[_c('stop',{attrs:{"stop-color":"#14CDE3","offset":"0%"}}),_c('stop',{attrs:{"stop-color":"#3A51AA","offset":"100%"}})])]),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('circle',{attrs:{"fill":"url(#a)","cx":"30","cy":"30","r":"30"}}),_c('path',{attrs:{"d":"M38.57 23.91a.606.606 0 00-.606.605v3.636a.606.606 0 101.212 0v-3.636a.606.606 0 00-.606-.606zm-17.428 0a.606.606 0 00-.606.605v3.636a.606.606 0 101.212 0v-3.636a.606.606 0 00-.606-.606zm18.05 17.29a16.564 16.564 0 00-10.504-2.917 16.213 16.213 0 00-3.83.76 7.272 7.272 0 00-1.098-3.151c-.772-1.188-1.713-1.863-2.618-1.863-.905 0-1.855.675-2.598 1.863-.889 1.381-1.616 3.68-.723 5.615.557 1.212 1.806 2.424 3.337 2.424 1.531 0 2.783-1.212 3.341-2.424.17-.375.287-.772.347-1.18a14.9 14.9 0 013.943-.836 15.332 15.332 0 019.733 2.707.61.61 0 00.84-.153.602.602 0 00-.17-.845zm-15.8-.198c-.275.602-1.095 1.738-2.238 1.738s-1.96-1.136-2.234-1.738c-.639-1.393-.138-3.232.638-4.444.513-.808 1.14-1.305 1.616-1.305.477 0 1.087.514 1.616 1.305.727 1.2 1.228 3.05.602 4.444z","fill":"#FFF","fill-rule":"nonzero"}})])])
          )
        }
      }
    